import { z } from 'zod';
import { requiredString } from '@/shared/lib/validation';

/** Проверяет данные ручного подтверждения оплаты заказа */
export const manualPaymentConfirmSchema = z.object({
    externalId: requiredString('Не указан номер платежа в Robokassa'),
    robokassaPaymentUrl: requiredString('Укажите ссылку на оплату в Robokassa'),
    comment: z.string(),
});

export type ManualPaymentConfirmFormValues = z.infer<typeof manualPaymentConfirmSchema>;

/** Создаёт начальные значения подтверждения для выбранного платежа */
export const getManualPaymentConfirmDefaults = (
    externalPaymentId: string | null | undefined,
): ManualPaymentConfirmFormValues => ({
    externalId: externalPaymentId ?? '',
    robokassaPaymentUrl: '',
    comment: '',
});
